// extracted by mini-css-extract-plugin
module.exports = {"root":"Notification_root__Py9iC","openAnimation":"Notification_openAnimation__QbiuI"};